import { __decorate, __metadata } from "tslib";
import { Component, Emit, Prop, Vue } from "vue-property-decorator";
/**
 * One Team Operations input in a section modal: plain free text, highlighted once changed.
 */
let TeamOperationsFieldInput = /** @class */ (() => {
    var _a;
    let TeamOperationsFieldInput = class TeamOperationsFieldInput extends Vue {
        onInput(event) {
            return event.target.value;
        }
    };
    __decorate([
        Prop({ default: "" }),
        __metadata("design:type", String)
    ], TeamOperationsFieldInput.prototype, "value", void 0);
    __decorate([
        Prop({ default: "" }),
        __metadata("design:type", String)
    ], TeamOperationsFieldInput.prototype, "label", void 0);
    __decorate([
        Prop({ default: "" }),
        __metadata("design:type", String)
    ], TeamOperationsFieldInput.prototype, "placeholder", void 0);
    __decorate([
        Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], TeamOperationsFieldInput.prototype, "modified", void 0);
    __decorate([
        Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], TeamOperationsFieldInput.prototype, "disabled", void 0);
    __decorate([
        Emit("input"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_a = typeof Event !== "undefined" && Event) === "function" ? _a : Object]),
        __metadata("design:returntype", void 0)
    ], TeamOperationsFieldInput.prototype, "onInput", null);
    TeamOperationsFieldInput = __decorate([
        Component({
            name: "TeamOperationsFieldInput",
        })
    ], TeamOperationsFieldInput);
    return TeamOperationsFieldInput;
})();
export default TeamOperationsFieldInput;
